import { useParams } from "react-router-dom";
import LocationConfigurations from "./LocationConfigurations";
import useAccountConfigQuery from "../../../hooks/data/queries/useAccountConfigQuery";
import HasAccess, { csrAdminRoles } from "../../../components/HasAccess";
import Error from "../../../components/Error";

type LocationRouteParams = {
  accountHolderCode: string;
  locationName: string;
};

function Location(): JSX.Element {
  const { accountHolderCode, locationName } = useParams<LocationRouteParams>();
  const { data: accountConfigData, isLoading: accountConfigIsLoading } =
    useAccountConfigQuery(accountHolderCode);

  const currentLocation = accountConfigData?.accounts.find(
    (x) => x.locationCode.toLowerCase() === locationName?.toLowerCase()
  );

  return (
    <div className="flex flex-col px-6">
      <HasAccess
        allowedRoles={[...csrAdminRoles]}
        notAllowedComponent={
          <Error message="You're not allowed to view this page." />
        }
      >
        <div>
          <div className="flex flex-wrap gap-4 lg:grid lg:grid-cols-12 lg:grid-rows-[auto_auto]">
            <LocationConfigurations
              accountHolderCode={accountHolderCode ?? ""}
              location={currentLocation}
              migrated={accountConfigData?.migrated ?? false}
              isLoading={accountConfigIsLoading ?? false}
            />
          </div>
        </div>
      </HasAccess>
    </div>
  );
}

export default Location;
